var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 463.672 463.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#070707;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 329.633,
    y1: 881.163,
    x2: 197.049,
    y2: 1135.114,
    gradientTransform: "translate(0 -766)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc1fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 271.665,
    y1: 850.899,
    x2: 139.082,
    y2: 1104.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 300.463,
    y1: 865.935,
    x2: 167.88,
    y2: 1119.885,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 231.836,
    cy: 231.836,
    r: 231.836,
    transform: "translate(-96.03 231.836) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.807,281.359a7.851,7.851,0,0,1,5.553-2.294H347.932a3.924,3.924,0,0,1,2.777,6.7l-37.844,37.844a7.856,7.856,0,0,1-5.553,2.293H115.739a3.923,3.923,0,0,1-2.776-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.807,140.063a8.072,8.072,0,0,1,5.553-2.293H347.932a3.923,3.923,0,0,1,2.777,6.7l-37.844,37.844a7.853,7.853,0,0,1-5.553,2.294H115.739a3.923,3.923,0,0,1-2.776-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.865,210.258a7.856,7.856,0,0,0-5.553-2.293H115.739a3.923,3.923,0,0,0-2.776,6.7l37.844,37.844a7.851,7.851,0,0,0,5.553,2.294H347.932a3.924,3.924,0,0,0,2.777-6.7Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.efa66aa8c5847bf8bc3332fa90f0dc71.svg";
export { ForwardRef as ReactComponent };